module.exports = __webpack_public_path__ + "static/img/cast.a132928.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/cast.gif
// module id = 62Lg
// module chunks = 1